import pageTopAlert from "./pageTopAlert/pageTopAlert.vue";
import breadcrumb from "./breadcrumb/breadcrumb.vue";
import squareButton from "./squareButton/squareButton.vue";
import handleBar from "./handleBar/handleBar.vue";
import handleBarNoWindowKey from "./handleBar/handleBarNoWindowKey.vue";
import doubleColumnsView from "./container/doubleColumnsView.vue";
import opName from "./opname/opname4.vue";

const components = [pageTopAlert, breadcrumb, squareButton, handleBar,handleBarNoWindowKey, doubleColumnsView, opName]
const install = function (Vue, opts = {}) {
  components.forEach((component) => {
    Vue.component(`wh${component.name}`, component);
  });
};
export default {
  install,
}



// WEBPACK FOOTER //
// ./src/components/index.js